var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 167,
    viewBox: "0 0 255 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1745,
    y: 45.4569,
    width: 229,
    height: 85,
    rx: 18,
    transform: "rotate(-11.1497 1.1745 45.4569)",
    fill: "url(#paint0_linear_540_949)",
    stroke: "#262626",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6486 76.3358C31.5748 73.9102 27.9576 74.6231 27.8845 77.2748C27.8752 77.6125 27.5345 77.8392 27.2194 77.7175C24.7449 76.7616 22.6913 79.8235 24.5146 81.7502C24.7468 81.9956 24.6662 82.3968 24.3574 82.5335C21.9317 83.6073 22.6447 87.2245 25.2963 87.2976C25.634 87.3069 25.8608 87.6476 25.739 87.9627C24.7832 90.4372 27.845 92.4908 29.7717 90.6675C30.0171 90.4353 30.4183 90.5159 30.5551 90.8247C31.6289 93.2504 35.2461 92.5375 35.3192 89.8858C35.3285 89.5481 35.6692 89.3213 35.9842 89.4431C38.4587 90.399 40.5124 87.3371 38.689 85.4104C38.4568 85.165 38.5374 84.7638 38.8463 84.627C41.2719 83.5533 40.559 79.936 37.9073 79.8629C37.5696 79.8536 37.3429 79.513 37.4646 79.1979C38.4205 76.7234 35.3586 74.6697 33.4319 76.4931C33.1866 76.7253 32.7853 76.6447 32.6486 76.3358Z",
    fill: "url(#paint1_radial_540_949)",
    stroke: "#262626",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.783 40.6566C211.71 38.231 208.092 38.9439 208.019 41.5956C208.01 41.9333 207.669 42.1601 207.354 42.0383C204.88 41.0824 202.826 44.1443 204.649 46.071C204.882 46.3164 204.801 46.7176 204.492 46.8543C202.066 47.9281 202.779 51.5453 205.431 51.6184C205.769 51.6278 205.996 51.9684 205.874 52.2835C204.918 54.758 207.98 56.8116 209.906 54.9883C210.152 54.7561 210.553 54.8367 210.69 55.1455C211.764 57.5712 215.381 56.8583 215.454 54.2066C215.463 53.8689 215.804 53.6421 216.119 53.7639C218.593 54.7198 220.647 51.6579 218.824 49.7312C218.592 49.4858 218.672 49.0846 218.981 48.9478C221.407 47.8741 220.694 44.2568 218.042 44.1837C217.704 44.1744 217.478 43.8338 217.599 43.5187C218.555 41.0442 215.493 38.9905 213.567 40.8139C213.321 41.0461 212.92 40.9655 212.783 40.6566Z",
    fill: "url(#paint2_radial_540_949)",
    stroke: "#262626",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6244 95.7007C69.7187 97.1275 68.2416 98.0427 66.193 98.4465C64.1445 98.8502 62.4207 98.5659 61.0217 97.5933C59.6424 96.6169 58.7411 95.0552 58.318 92.9081L52.8439 65.1341C52.3353 62.5537 52.6011 60.4243 53.6414 58.7459C54.7013 57.0637 56.4427 55.9838 58.8655 55.5063L70.3002 53.2526C72.3487 52.8488 74.063 53.0328 75.4428 53.8044C76.8424 54.5722 77.715 55.8326 78.0605 57.5857C78.406 59.3389 78.0809 60.8558 77.0851 62.1366C76.0854 63.3977 74.5711 64.2282 72.5422 64.6281L69.2034 65.2862C67.3518 65.6511 66.5774 66.6018 66.8802 68.1382L66.8919 68.1973C67.1947 69.7338 68.2719 70.3195 70.1235 69.9546L72.31 69.5236C74.1222 69.1665 75.6317 69.3498 76.8384 70.0738C78.0413 70.778 78.8039 71.9476 79.1261 73.5825C79.4561 75.2568 79.1942 76.6794 78.3405 77.8504C77.5064 79.0175 76.1931 79.7777 74.4006 80.131L72.2141 80.5619C71.3671 80.7288 70.75 81.0756 70.3626 81.6021C69.9911 82.105 69.883 82.7505 70.0383 83.5384L71.3777 90.3342C71.8008 92.4812 71.5498 94.2701 70.6244 95.7007Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4313 94.7032C84.5009 95.0837 82.8185 94.8014 81.384 93.8563C79.9692 92.9074 79.0735 91.4776 78.6969 89.5669C78.3203 87.6562 78.6065 85.9934 79.5554 84.5786C80.524 83.1599 81.9736 82.2603 83.9039 81.8799C85.8146 81.5033 87.4675 81.7914 88.8627 82.7442C90.2578 83.697 91.1436 85.1288 91.5202 87.0395C91.8968 88.9502 91.6205 90.611 90.6912 92.0219C89.762 93.4329 88.342 94.3266 86.4313 94.7032Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.829 91.2258C100.76 91.6335 99.0482 91.4594 97.6919 90.7035C96.3553 89.9438 95.5084 88.6579 95.1512 86.8457C95.0115 86.1365 95.0228 84.8963 95.1853 83.1249L97.7104 54.5109C97.9137 52.2199 98.6493 50.3458 99.9173 48.8886C101.181 47.4117 102.867 46.4655 104.975 46.0501C107.083 45.6347 109.001 45.8704 110.731 46.7572C112.458 47.6243 113.849 49.0791 114.907 51.1217L128.16 76.6259C128.908 78.0336 129.377 79.2201 129.567 80.1853C129.913 81.9384 129.601 83.422 128.633 84.6359C127.681 85.8263 126.2 86.6195 124.191 87.0155C123.206 87.2096 122.346 87.2564 121.61 87.1559C120.878 87.0751 120.225 86.8252 119.651 86.4062C119.077 85.9873 118.6 85.539 118.22 85.0616C117.835 84.5644 117.386 83.8957 116.873 83.0556C116.5 82.4128 116.161 81.9886 115.855 81.783C115.548 81.5774 115.139 81.525 114.626 81.626L109.544 82.6276C109.052 82.7247 108.703 82.9265 108.497 83.233C108.311 83.5357 108.158 84.0569 108.038 84.7968C107.838 86.1665 107.579 87.2407 107.261 88.0194C106.944 88.7981 106.432 89.472 105.726 90.0409C105.016 90.5902 104.05 90.9851 102.829 91.2258ZM111.492 72.7285C111.846 72.6586 112.085 72.5195 112.207 72.3112C112.326 72.0831 112.307 71.8311 112.15 71.555L107.788 60.3212L107.943 72.3229C107.965 73.0553 108.32 73.3536 109.01 73.2177L111.492 72.7285Z",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.838 84.177C137.908 84.5575 136.226 84.2752 134.791 83.3302C133.376 82.3812 132.481 80.9514 132.104 79.0407C131.727 77.13 132.014 75.4673 132.963 74.0525C133.931 72.6338 135.381 71.7342 137.311 71.3537C139.222 70.9771 140.875 71.2652 142.27 72.2181C143.665 73.1709 144.551 74.6026 144.927 76.5133C145.304 78.424 145.028 80.0848 144.098 81.4958C143.169 82.9067 141.749 83.8005 139.838 84.177Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.507 83.8998C174.483 84.1016 173.527 84.0242 172.638 83.6673C171.749 83.3105 170.255 82.4794 168.156 81.1742C167.13 80.5374 166.22 80.1234 165.425 79.9322C164.63 79.741 163.601 79.6574 162.337 79.6814C160.407 79.7547 158.974 79.7507 158.037 79.6694C157.096 79.5683 156.117 79.3214 155.098 78.9288C148.364 76.4294 144.071 70.4817 142.219 61.0858C140.919 54.4871 141.494 48.8897 143.944 44.2937C146.413 39.6938 150.357 36.8601 155.774 35.7924C161.132 34.7365 165.818 35.8796 169.833 39.2219C173.843 42.5444 176.497 47.4953 177.794 54.0744C178.555 57.9352 178.661 61.5874 178.112 65.0311C177.582 68.4709 176.35 71.3536 174.414 73.6791C174.874 73.834 175.328 74.0105 175.777 74.2086C177.008 74.7436 177.886 75.3071 178.412 75.8992C178.954 76.4677 179.308 77.1755 179.475 78.0225C179.762 79.4801 179.562 80.7474 178.874 81.8243C178.205 82.8974 177.083 83.5892 175.507 83.8998ZM161.963 67.5079C163.342 67.2361 164.253 66.146 164.695 64.2376C165.153 62.3056 165.078 59.7933 164.468 56.7008C163.866 53.6476 162.989 51.324 161.836 49.7301C160.698 48.1126 159.44 47.4397 158.062 47.7115C156.663 47.9871 155.735 49.0909 155.276 51.0229C154.834 52.9313 154.914 55.4121 155.515 58.4653C156.125 61.5579 156.998 63.9129 158.136 65.5304C159.289 67.1244 160.565 67.7835 161.963 67.5079Z",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.118 74.4644C187.187 74.8449 185.505 74.5626 184.07 73.6175C182.656 72.6686 181.76 71.2388 181.383 69.3281C181.007 67.4174 181.293 65.7546 182.242 64.3398C183.211 62.9211 184.66 62.0216 186.59 61.6411C188.501 61.2645 190.154 61.5526 191.549 62.5054C192.944 63.4583 193.83 64.89 194.207 66.8007C194.583 68.7114 194.307 70.3722 193.378 71.7832C192.448 73.1941 191.029 74.0878 189.118 74.4644Z",
    fill: "#262626"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208.059,
    cy: 120.34,
    r: 40.5,
    transform: "rotate(6.80337 208.059 120.34)",
    fill: "#F85A17",
    stroke: "#262626",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.163 119.926C204.884 130.652 198.656 138.727 192.252 137.963C185.849 137.199 181.696 127.885 182.975 117.16C184.255 106.435 190.483 98.3591 196.886 99.123C203.289 99.8869 207.443 109.201 206.163 119.926Z",
    fill: "url(#paint3_radial_540_949)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.417 118.389C183.932 114.066 187.465 110.934 191.307 111.392C195.149 111.851 197.845 115.726 197.33 120.048C196.814 124.371 193.281 127.503 189.44 127.044C185.598 126.586 182.901 122.711 183.417 118.389Z",
    fill: "url(#paint4_linear_540_949)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.431 119.703C194.106 122.424 191.766 124.382 189.205 124.077C186.644 123.771 184.831 121.317 185.155 118.596C185.48 115.875 187.82 113.916 190.381 114.222C192.942 114.527 194.755 116.981 194.431 119.703Z",
    fill: "#262626"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.139 112.8C188.226 112.453 185.267 114.851 184.825 118.556C184.383 122.262 186.694 125.289 189.607 125.637C192.521 125.984 195.48 123.586 195.922 119.88C196.364 116.175 194.052 113.148 191.139 112.8ZM191.307 111.392C187.465 110.934 183.932 114.066 183.417 118.389C182.901 122.711 185.598 126.586 189.44 127.044C193.281 127.503 196.814 124.371 197.33 120.048C197.845 115.726 195.149 111.851 191.307 111.392Z",
    fill: "url(#paint5_linear_540_949)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M188.973 116.82C188.389 117.756 187.308 118.136 186.559 117.668C185.811 117.201 185.677 116.063 186.262 115.127C186.846 114.191 187.927 113.812 188.676 114.279C189.424 114.747 189.558 115.884 188.973 116.82Z",
    fill: "#FBF2C3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232.251 123.039C230.971 133.764 224.743 141.84 218.34 141.076C211.937 140.312 207.783 130.998 209.063 120.272C210.342 109.547 216.57 101.471 222.974 102.235C229.377 102.999 233.53 112.313 232.251 123.039Z",
    fill: "url(#paint6_radial_540_949)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209.504 121.501C210.02 117.179 213.552 114.046 217.394 114.505C221.236 114.963 223.933 118.838 223.417 123.161C222.901 127.483 219.369 130.615 215.527 130.157C211.685 129.698 208.988 125.823 209.504 121.501Z",
    fill: "url(#paint7_linear_540_949)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.226 115.913C214.313 115.565 211.354 117.964 210.912 121.669C210.47 125.374 212.782 128.401 215.695 128.749C218.608 129.096 221.567 126.698 222.009 122.993C222.451 119.288 220.139 116.26 217.226 115.913ZM217.394 114.505C213.552 114.046 210.02 117.179 209.504 121.501C208.988 125.823 211.685 129.698 215.527 130.157C219.369 130.615 222.901 127.483 223.417 123.161C223.933 118.838 221.236 114.963 217.394 114.505Z",
    fill: "url(#paint8_linear_540_949)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.518 122.815C220.193 125.536 217.854 127.495 215.292 127.189C212.731 126.883 210.918 124.43 211.243 121.708C211.567 118.987 213.907 117.028 216.468 117.334C219.03 117.64 220.843 120.093 220.518 122.815Z",
    fill: "#262626"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M215.061 119.933C214.476 120.868 213.396 121.248 212.647 120.781C211.898 120.313 211.765 119.176 212.349 118.24C212.934 117.304 214.014 116.924 214.763 117.391C215.512 117.859 215.645 118.997 215.061 119.933Z",
    fill: "#FBF2C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_540_949",
    x1: 115.5,
    y1: 44.6691,
    x2: 115.5,
    y2: 131.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_540_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6018 83.5803) rotate(78.8503) scale(6.41799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_540_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.737 47.9011) rotate(78.8503) scale(6.41799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_540_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.569 118.543) rotate(96.8034) scale(19.5579 11.6763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_540_949",
    x1: 189.44,
    y1: 127.044,
    x2: 191.307,
    y2: 111.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_540_949",
    x1: 189.44,
    y1: 127.044,
    x2: 191.307,
    y2: 111.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_540_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.657 121.655) rotate(96.8034) scale(19.5579 11.6763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_540_949",
    x1: 215.527,
    y1: 130.157,
    x2: 217.394,
    y2: 114.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_540_949",
    x1: 215.527,
    y1: 130.157,
    x2: 217.394,
    y2: 114.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.a20de212d1b6bf939c1fa4ae5cf55210.svg";
export { ForwardRef as ReactComponent };